<script>
import PriceComponent from './Price/component.vue';
import InfoComponent from './Info/component.vue';
import ProgramComponent from './Program/component.vue';
import TermComponent from './Term/component.vue';
import DatesComponent from './Dates/component.vue';
import TariffsComponent from './Tariffs/component.vue';
import TouristComponent from './Tourist/component.vue';
import HotelComponent from './Hotel/component.vue';
import AdditionalServiceComponent from './AdditionalService/component.vue';
import SeatingArrangementsComponent from './SeatingArrangements/component.vue';
export default {
  components: {
    PriceComponent,
    InfoComponent,
    ProgramComponent,
    TermComponent,
    DatesComponent,
    TariffsComponent,
    TouristComponent,
    HotelComponent,
    SeatingArrangementsComponent,
    AdditionalServiceComponent
  },
  props: {
    module: Object,
    link: String,
    id: String,
    isWidget: {
      type: Boolean,
      default: false,
    },
    isAuth: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    tab: 'program',
    tabs: [
      {
        label: 'Программа тура',
        value: 'program',
      },
      {
        label: 'Условия',
        value: 'term',
      },
      {
        label: 'Бронирование',
        value: 'main',
      },
    ],
  }),
  watch: {
    id() {
      this.init();
    },
    isAuth() {
      this.setAuthData();
    },
  },
  methods: {
    redirect(id) {
      this.$router.push(`${this.link}/${id}`);
    },
    async init() {
      await this.module.getById(this.id);
      await this.module.init();
      this.setAuthData();
    },
    handlerSubmit() {
      if (!this.isAuth && this.module.tourist.payer === 'agency') {
        this.$emit('get_login', () => this.handlerSubmit());
        return;
      }
      this.module.submit()
        .then((data) => {
          if (data.success) {
            this.$emit('success', data);
          } else {
            this.$core.notify.error('Ошибка при бронировании');
          }
        })
        .catch((e) => {
          this.tab = 'main';
          setTimeout(() => {
          });
        });
    },
    setAuthData() {
      if (this.isAuth) {
        this.module.tourist.payer = 'agency';
        this.module.tourist.type = 'preorder';
      } else {
        this.module.tourist.payer = 'client';
        this.module.tourist.type = 'pay';
      }
    },
  },
  mounted() {
    this.init();
    setTimeout(() => {
      this.$refs.scroll.scrollIntoView();
    });
  },
};
</script>
<template>
  <div class="p-t-c-i" v-if="module">
    <div class="mag-scroll-top" ref="scroll"></div>
    <div class="p-t-c-i__flex">
      <div class="p-t-c-i__wrap">
        <InfoComponent
          :module="module.info"
        />
        <DatesComponent
          :module="module.dates"
          :value="module.id"
          @click="redirect"
        />
        <TariffsComponent
          :module="module.tariffs"
          @click="redirect"
        />
        <SeatingArrangementsComponent
          :module="module.seat"
          v-if="module.seat.showTransfer"
          @click="redirect"
        />
        <HotelComponent
          :module="module.hotel"
          v-if="module.hotel.hotels.length"
        />
        <AdditionalServiceComponent
          :module="module.additionalService"
          v-if="module.additionalService.services.length"
        />
        <Card>
          <CardTabs
            v-model="tab"
            :items="tabs"
          />
          <TouristComponent
            v-show="tab === 'main'"
            :module="module.tourist"
            :isWidget="isWidget"
            :isAuth="isAuth"
          />
          <ProgramComponent
            v-show="tab === 'program'"
            :module="module.program"
          />
          <TermComponent
            v-show="tab === 'term'"
            :module="module.term"
          />
          <div>
            <textarea class="mag-tour-reservation-comment" v-model="module.comment" placeholder="Ваш комментарий к заказу"></textarea>
          </div>
          <CardFooter>
            <BtnPrimary
              @click="handlerSubmit"
            >Забронировать
            </BtnPrimary>
          </CardFooter>
        </Card>
      </div>
      <div class="mag-tour-price-block p-t-c-i__price">
        <PriceComponent
          :module="module.price"
          @submit="handlerSubmit"
        />
      </div>
    </div>
  </div>
</template>
<style lang="scss">

  @media only screen and (max-width: 1000px) {

    .mag-tour-price-block {
      display: none;
    }
  }

  .mag-tour-reservation-comment {
    resize: both;
    width: 100%;
  }

  .p-t-c-i {
    &__flex {
      display: flex;
    }

    &__wrap {
      flex: 1;
    }

    &__price {
      width: 300px;
      flex-shrink: 0;
      margin: 0 0 0 24px;
    }
  }

  @media (max-width: 1000px) {
    .p-t-c-i__flex {
      display: block;
    }
    .p-t-c-i__price {
      width: 100%;
      margin: 0;
    }
  }

  @media (max-width: 600px) {
    .p-t-c-i {
      .card-tabs {
        display: block;
      }
    }
  }
</style>
